import { EventsTransformService } from './events-transform.service';

export default angular
  .module('sfMobile.services.events-transform', [])
  .service('eventsTransformService', EventsTransformService).name;
